import { BaseService } from "./base.service";
export class ProgramTemplateCriteriaCategoryService extends BaseService {
  constructor() {
    super("program-template-criterion-categories");
  }
}
